import { FC, RefObject } from 'react';
import { FormattedMessage } from 'react-intl';

import styles from '../../Encounters.module.scss';
import { EncountersListState as EncountersListStateType } from '../../hooks';
import { EncounterGroup } from '../../lib/groupEncountersByDay';

import { EncounterListGroup } from './EncounterListGroup';
import { EncountersListState } from './EncountersListState';

type EncountersListProps = {
  groups: EncounterGroup[];
  hasMore: boolean;
  listState: EncountersListStateType;
  loadingMore: boolean;
  selectedEncounterId: string | undefined;
  sentinelRef: RefObject<HTMLDivElement>;
  onSelect: (encounterId: string) => void;
};

export const EncountersList: FC<EncountersListProps> = (props) => {
  const {
    groups,
    hasMore,
    listState,
    loadingMore,
    selectedEncounterId,
    sentinelRef,
    onSelect,
  } = props;

  return (
    <>
      <EncountersListState state={listState} />

      {groups.map((group) => (
        <EncounterListGroup
          key={group.dayKey}
          group={group}
          selectedEncounterId={selectedEncounterId}
          onSelect={onSelect}
        />
      ))}

      {hasMore && <div ref={sentinelRef} className={styles.sentinel} />}

      {loadingMore && (
        <div className={styles.state}>
          <FormattedMessage
            id="encounters.loadingMore"
            defaultMessage="Loading more…"
          />
        </div>
      )}
    </>
  );
};
